import * as React from 'react';

import {RouteComponentProps} from 'react-router';
import LessonComponent from './components/lesson/LessonComponent';
import LessonApi from '../modules/lessons/api/LessonApi';
import Lesson from '../modules/lessons/domain/aggregates/lesson/Lesson';
import EntityId from '../../foundation/domain/EntityId';
import Page from './Page';
import CourseApi from '../modules/lessons/api/CourseApi';
import Course from '../modules/lessons/domain/aggregates/course/Course';
import { Header, Button, Table, Breadcrumb, Tab, Dropdown, Icon } from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import ExerciseApi from '../modules/lessons/api/ExerciseApi';
import Exercise from '../modules/lessons/domain/aggregates/exercise/Exercise';
import SearchQueryParser from '../../foundation/parsers/SearchQueryParser';
import Registry from '../global/Registry';
import LessonResultApi from '../modules/lessons/api/LessonResultApi';
import BBMLParser from './components/exercises/BBMLParser';
import * as Voca from 'voca';

interface Props {
	id: string;
	activeTab?: string;
}

interface State {
	activeTab: string;
	showAnswers: boolean;
	lesson?: Lesson;
	course?: Course;
	exercises: Exercise[];
}

export default class LessonPage extends Page<RouteComponentProps<Props>, State> {

	public constructor (props: RouteComponentProps<Props>) {
		super(props);

		this.state = { activeTab: 'story', exercises: [], showAnswers: true };
	}

	async componentWillMount () {
		const query = SearchQueryParser.execute(this.props.location.search);

		const activeTab = this.props.match.params.activeTab !== undefined ? this.props.match.params.activeTab : 'story';
		const lessonId = new EntityId<Lesson>(Number(this.props.match.params.id));
		const lesson = await LessonApi.getInstance().getById(lessonId);
		const courses = await CourseApi.getInstance().getAll();
		const exercises = await ExerciseApi.getInstance().getAllByLessonId(lessonId);

		const course = courses.find(course => course.getId().equals(lesson.getCourseId()));

		this.setState({lesson, course, exercises, activeTab, showAnswers: activeTab === 'exercises' && query.hideAnswers !== 'true' });
	}

	componentWillReceiveProps (props: RouteComponentProps<Props>) {
		const query = SearchQueryParser.execute(props.location.search);

		const activeTab = props.match.params.activeTab !== undefined ? props.match.params.activeTab : 'story';

		this.setState({activeTab: activeTab, showAnswers: activeTab === 'exercises' && query.hideAnswers !== 'true'});
	}

	// protected getCanonicalUrl () {
	// 	return this.state.activeTab === 'exercises' && this.state.lesson instanceof Lesson ? this.state.lesson.getSlug() + '/exercises' : null;
	// }

	protected isLoading () {
		return this.state.lesson === undefined;
	}

	protected renderTitle () {
		return Voca.stripTags((this.state.lesson as Lesson).getTitle()) + ' - Math & Science - Brain Brooder';
	}

	protected renderDescription () {
		return 'Learn "' + Voca.stripTags((this.state.lesson as Lesson).getTitle()) + '" and other lessons in our free math and science courses. Our platform will make sure you will never forget anything.';
	}

	protected renderContent () {
		const me = Registry.getInstance().me;
		const course = this.state.course as Course;
		const lesson = this.state.lesson as Lesson;

		const sections = [{ key: 'Home', content: <Link to={course.isPublic() ? '/' : '/my-courses'}>Home</Link> }, { key: 'Course', content: <Link to={course.getSlug()}>{course.getName()}</Link> }, { key: 'Lesson', content: BBMLParser.execute(lesson.getTitle()), active: true}];

		const dropdown = (
			<Dropdown icon='cogs' pointing='top right' floating compact button className='icon right floated inverted' style={{marginTop: '60px'}}>
				<Dropdown.Menu>
					<Dropdown.Item icon='pencil' text='Edit lesson' onClick={() => Page.navigate(lesson.getSlug() + '/edit')} />
					{me.isErik() ? <Dropdown.Item icon='newspaper' text={lesson.hasContent() ? 'Edit the story' : 'Add a story'} onClick={() => Page.navigate(lesson.getSlug() + '/edit-story')} /> : null}
					<Dropdown.Item icon='puzzle' text='Add an exercise' onClick={() => Page.navigate(lesson.getSlug() + '/exercise/new')} />
				</Dropdown.Menu>
			</Dropdown>
		);

		return (
			<div className='lesson'>
				<Breadcrumb icon='right angle' sections={sections} />

				{me.isErik() || me.getId().equals(course.getUserId()) ? dropdown : null}

				<Header as='h1' dividing inverted content={BBMLParser.execute(lesson.getTitle())} subheader={lesson.getSubtitle()} />

				{!lesson.hasContent() && this.state.exercises.length === 0 ? this.renderBlankSlate(lesson) : this.renderLessonContents(course, lesson)}
			</div>
		);
	}

	private renderBlankSlate (lesson: Lesson) {
		return (
			<div style={{textAlign: 'center'}}>
				<div style={{margin: '48px 0'}}>
					<h2>This lesson doesn't contain any exercises yet.</h2>
				</div>
				<p><Button inverted size={'big'} color={'green'} onClick={() => Page.navigate(lesson.getSlug() + '/exercise/new')}><Icon name={'plus'} />  Create the first exercise</Button></p>
			</div>
		);

		// return (
		// 	<div>
		// 		<p>Your lesson is empty.</p>
		//
		// 		<p>
		// 			A lesson consists of a list of <strong>exercises</strong> and optionally a <strong>story</strong>.
		// 		</p>
		//
		// 		<p>
		// 			The exercises can be used to learn new vocabulary, to practice math, or for anything else that you want to remember or practice.
		// 		</p>
		//
		// 		<p>
		// 			You can optionally add a story to explain some concepts that should be understood before doing the exercises.
		// 		</p>
		//
		// 		<div style={{margin: '32px 0'}}>
		// 			<Button href='/' rel='nofollow' size='large' inverted icon='puzzle' labelPosition='left' content='Add exercises' onClick={(event: React.SyntheticEvent<HTMLButtonElement>) => { Page.navigate(lesson.getSlug() + '/exercise/new'); event.preventDefault(); }} />
		// 			<Button href='/' rel='nofollow' size='large' inverted icon='newspaper' labelPosition='left' content='Add a story' onClick={(event: React.SyntheticEvent<HTMLButtonElement>) => { Page.navigate(lesson.getSlug() + '/edit-story'); event.preventDefault(); }} />
		// 		</div>
		// 	</div>
		// );
	}

	private renderLessonContents (course: Course, lesson: Lesson) {
		const activeTab = this.state.activeTab;

		return (
			<div>
				{lesson.hasContent() ? (
					<div className={'tabs2'} style={{marginTop: '24px'}}>
						<input id='tab1' type='radio' name='tabs' checked={activeTab === 'story' && lesson.hasContent()} readOnly />
						<label id='label1' onClick={() => Page.navigate(lesson.getSlug())}><Icon name={'newspaper'} /> <span><Link style={{color: 'inherit'}} to={lesson.getSlug()}>Story</Link></span></label>

						<input id='tab2' type='radio' name='tabs' readOnly checked={activeTab === 'exercises'} />
						<label id='label2' onClick={() => Page.navigate(lesson.getSlug() + '/exercises')}><Icon name={'puzzle'} /> <span><Link style={{color: 'inherit'}} to={lesson.getSlug() + '/exercises'}>Exercises</Link></span></label>

						<section id='content1'>
							{<LessonComponent lesson={lesson} course={course} />}
						</section>

						<section id='content2'>
							{this.renderExercises()}
						</section>
					</div>
				) : (
					this.renderExercises()
				)}

				<div style={{margin: '32px 0', textAlign: 'center'}}>
					{this.renderActionButton(course, lesson)}
				</div>
			</div>
		);
	}

	private renderActionButton (course: Course, lesson: Lesson) {
		if (this.state.exercises.length === 0) {
			return (
				<div>
					<p style={{color: 'grey', fontSize: '0.9em'}}>This lesson has no exercises.</p>
					<Button size='large' color={'green'} inverted icon='long arrow right' labelPosition='left' content='Mark this lesson as completed' onClick={async (event: React.SyntheticEvent<HTMLButtonElement>) => { await LessonResultApi.getInstance().markAsCompleted(lesson.getId()); Page.navigate(course.getSlug()); }} />
				</div>
			);
		}

		return <Button size='large' color={'green'} inverted icon='long arrow right' labelPosition='left' content='Practice the exercises' onClick={(event: React.SyntheticEvent<HTMLButtonElement>) => { Page.navigate('/lesson/' + lesson.getId().getValue() + '/exercises'); event.preventDefault(); }} />;
	}

	private renderExercises () {
		const lesson = this.state.lesson as Lesson;
		const course = this.state.course as Course;
		const showAnswers = true; // this.state.showAnswers;
		const me = Registry.getInstance().me;
		const canEdit = me.isErik() || me.getId().equals(course.getUserId());

		if (this.state.exercises.length === 0) {
			return null;
		}

		return (
			<div>
				{this.state.exercises.length > 10 ?
					<div style={{position: 'sticky', top: '48px', height: '56px', backgroundColor: '#1d1d1d', padding: '8px', textAlign: 'center'}}>
						<Button size='large' color={'green'} inverted icon='long arrow right' labelPosition='left' content='Practice the exercises' onClick={(event: React.SyntheticEvent<HTMLButtonElement>) => { Page.navigate('/lesson/' + lesson.getId().getValue() + '/exercises'); event.preventDefault(); }} />
					</div>
				: null}

				<Table inverted celled unstackable selectable={true} style={{textAlign: 'center'}}>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell colSpan={2}>{this.state.exercises.length} {this.state.exercises.length === 1 ? 'exercise' : 'exercises'} {!showAnswers ? <Link to={lesson.getSlug() + '/exercises'}><Button icon={'unhide'} inverted compact className='right floated' /></Link> : null}</Table.HeaderCell>
							{/*{showAnswers ? <Table.HeaderCell><Link to={lesson.getSlug() + '/exercises?hideAnswers=true'}><Button icon={'hide'} inverted compact className='right floated' /></Link></Table.HeaderCell> : null}*/}
						</Table.Row>
					</Table.Header>
					<Table.Body>
						{this.state.exercises.map((exercise, index) => (
							<Table.Row key={index} onClick={() => canEdit ? Page.navigate(lesson.getSlug() + '/exercise/' + exercise.getId().getValue() + '/edit') : Page.navigate(exercise.getSlug())}>
								<Table.Cell>{exercise.getQuestion()}</Table.Cell>
								{showAnswers ? <Table.Cell><Link style={{color: 'inherit'}} to={canEdit ? lesson.getSlug() : exercise.getSlug()}>{typeof exercise.getAnswer() === 'string' ? (exercise.getAnswer() as string).split('\n').map(answer => <div>{answer}</div>) : exercise.getAnswer()}</Link></Table.Cell> : null}
							</Table.Row>
						))}
					</Table.Body>
				</Table>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/LessonPage.tsx